/*
  Блок, свёрнутый до заголовка-кнопки.

  🔴 Указание владельца 18.09.2026: памятка «Где это взять» должна прятаться под
  кнопкой. Причина видна на экране загрузки: памятка занимает пол-экрана - три
  абзаца, таблица образца и кнопка скачивания, - и стоит она НАД полем выбора
  файла. Человеку, который грузит выгрузку второй раз в месяц, она уже не нужна,
  а прокручивать её приходится каждый раз.

  Свёрнут по умолчанию - в этом и смысл правки. Развёрнутое состояние живёт в
  самом блоке и не запоминается между открытиями страницы: запоминать его
  значило бы решать за человека, что он памятку прочитал.

  Заголовок - кнопка, а не строка со значком: по нему нажимают, и читалка
  экрана обязана называть его кнопкой и говорить, раскрыт он или нет
  (`aria-expanded`). Подъёма при наведении у него нет (`no-hover-lift`):
  заголовок во всю ширину карточки кнопкой не выглядит, и прыгающая под
  курсором карточка читалась бы как ошибка оформления.
*/

import { useState } from 'react'

export default function Disclosure({ title, counter, children }) {
  const [open, setOpen] = useState(false)

  return (
    <section className="section card disclosure">
      <button
        type="button"
        className="disclosure__head no-hover-lift"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <span className="disclosure__title">{title}</span>
        {/*
          Счётчик сразу за названием (21.09.2026, указание владельца: «счётчик в
          конце текста - сколько есть из скольки»). Свёрнутый блок обязан
          отвечать на главный вопрос сам: человек грузит файл ровно затем, чтобы
          собранного стало больше, и раскрывать блок ради одного числа ему
          незачем.
        */}
        {counter ? <span className="disclosure__counter">{counter}</span> : null}
        <span className="disclosure__sign">{open ? 'скрыть' : 'показать'}</span>
      </button>
      {open ? <div className="disclosure__body">{children}</div> : null}
    </section>
  )
}
